// src/locales/en/language.js
export const language = {
    selectLanguage: "மொழியைத் தேர்ந்தெடுக்கவும்",
    currentLanguage: "தற்போதைய மொழி",
    english: "ஆங்கிலம்",
    sinhala: "சிங்களம்",
    tamil: "தமிழ்"
}